exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".config-container[data-v-2c9cc6b6]{padding:20px 10px 30px;max-height:700px;overflow-y:auto;position:relative}.config-container .right-container[data-v-2c9cc6b6]{text-align:center;height:30px}", ""]);

// exports
